var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{class:_vm.outlined ? 'btn-outlined' : 'btn-default',attrs:{"color":_vm.color,"type":_vm.type,"outlined":_vm.outlined,"disabled":_vm.disabled,"height":_vm.height,"width":_vm.width,"depressed":""},on:{"click":_vm.handleClick}},[_c('span',{class:_vm.fontSize ? 'button-random' : 'label-button'},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }